import React, { useEffect } from "react";

import { AuthProvider, useAuth } from './context/AuthContext';
import AppRoutes from './routes/AppRoutes';
import ChatSystem from "./ChatSystem";
import { useLocation } from "react-router-dom";

function App() {
   const location = useLocation();

  const hiddenPaths = ["login", "register-as-manager", "register-as-staff"];
  const hideChat = hiddenPaths.some(path => location.pathname.includes(path));

  return (
    <AuthProvider>
      <AppRoutes />
       {!hideChat && <ChatSystem />}

    </AuthProvider>
  );
}

export default App;
